var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-alert-list',{attrs:{"get-params":_vm.params,"data":_vm.data,"alertType":_vm.params.type,"metric-opts":_vm.metricOpts,"list-id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }